import { Flex } from '../../../../summary/components/Flex.tsx';
import { Typography } from '../../../../summary/components/Typography.tsx';
import { SummarySection } from '../../SummarySection.tsx';
import { TitleAndExportToggleLockup } from '../../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';
import { AdjustmentBreakdownDepreciatedCostAdditionalImprovementsBasement } from '../AdjustmentBreakdownDepreciatedCostAdditionalImprovementsBasement.tsx';
import { AdjustmentBreakdownDepreciatedCostAdditionalImprovementsGarage } from '../AdjustmentBreakdownDepreciatedCostAdditionalImprovementsGarage.tsx';
import { AdjustmentBreakdownDepreciatedCostAdditionalImprovementsManual } from '../AdjustmentBreakdownDepreciatedCostAdditionalImprovementsManual.tsx';
import { AdjustmentBreakdownDepreciatedCostAdditionalImprovementsPatioDeck } from '../AdjustmentBreakdownDepreciatedCostAdditionalImprovementsPatioDeck.tsx';
import { AdjustmentBreakdownAdditionalStructureAdu } from './AdjustmentBreakdownAdditionalStructureAdu.tsx';
import { AdjustmentBreakdownAdditionalStructureAttic } from './AdjustmentBreakdownAdditionalStructureAttic.tsx';
import { AdjustmentBreakdownAdditionalStructureBarn } from './AdjustmentBreakdownAdditionalStructureBarn.tsx';
import { AdjustmentBreakdownAdditionalStructureBelowGradeAnsi } from './AdjustmentBreakdownAdditionalStructureBelowGradeANSI.tsx';
import { AdjustmentBreakdownAdditionalStructureBonusRoom } from './AdjustmentBreakdownAdditionalStructureBonusRoom.tsx';
import { AdjustmentBreakdownAdditionalStructureManufactured } from './AdjustmentBreakdownAdditionalStructureManufactured.tsx';
import { AdjustmentBreakdownAdditionalStructurePool } from './AdjustmentBreakdownAdditionalStructurePool.tsx';
import { AdjustmentBreakdownAdditionalStructureShed } from './AdjustmentBreakdownAdditionalStructureShed.tsx';
import { AdjustmentBreakdownAdditionalStructureWorkshop } from './AdjustmentBreakdownAdditionalStructureWorkshop.tsx';

export const AdjustmentBreakdownDepreciatedCostAdditionalImprovements = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <SummarySection>
    <TitleAndExportToggleLockup
      {...props}
      title="Additional Improvements"
      id="isDepreciatedCostAdditionalImprovementsInExport"
      variant="h2"
    />
    <Flex marginBottom="2rem">
      <Typography variant="body1">
        For other improvements, adjustments reflect the difference in depreciated cost between the
        subject and each comparable.
      </Typography>
    </Flex>
    <AdjustmentBreakdownDepreciatedCostAdditionalImprovementsBasement {...props} />
    <AdjustmentBreakdownDepreciatedCostAdditionalImprovementsGarage {...props} />
    <AdjustmentBreakdownDepreciatedCostAdditionalImprovementsPatioDeck {...props} />
    <AdjustmentBreakdownAdditionalStructureAttic {...props} />
    <AdjustmentBreakdownAdditionalStructureBelowGradeAnsi {...props} />
    <AdjustmentBreakdownAdditionalStructureBarn {...props} />
    <AdjustmentBreakdownAdditionalStructureBonusRoom {...props} />
    <AdjustmentBreakdownAdditionalStructureAdu {...props} />
    <AdjustmentBreakdownAdditionalStructureManufactured {...props} />
    <AdjustmentBreakdownAdditionalStructurePool {...props} />
    <AdjustmentBreakdownAdditionalStructureShed {...props} />
    <AdjustmentBreakdownAdditionalStructureWorkshop {...props} />
    <AdjustmentBreakdownDepreciatedCostAdditionalImprovementsManual {...props} />
  </SummarySection>
);
